import React, { useCallback } from 'react';
import { Link, Route, Switch, useHistory } from 'react-router-dom';
import ManifestPage from './ManifestPage';
import Button from '../../components/Button/Button';
import { Icon } from '../../components/Icon/Icon';
import Paper from '../../components/Paper/Paper';
import Modal from '../../components/Modal/Modal';
import withStyles from 'react-jss';
import ManifestAddForm from '../../views/Manifest/ManifestAddForm';
import ManifestList from '../../views/Manifest/ManifestList';
import { useLinkHandler } from '../../services/Utils/linkHandler';

const styles = {
  listContainer: {
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    gridTemplateRows: 'auto 1fr',
    gridTemplateAreas: '"title add" "list list"',
    padding: 10,
    overflow: 'auto',
    height: '100%',
  },
  title: {},
  add: {
    gridArea: 'add',
    justifySelf: 'self-end',
    margin: 10,
  },
  list: {
    paddingTop: 0,
    paddingBottom: 0,
    gridArea: 'list',
  },
};

const ManifestListPage = ({ classes }) => {
  const history = useHistory();

  const handleAdd = (manifestId) => {
    history.push('/manifests/' + manifestId);
  };

  const handleAbort = () => {
    history.push('/manifests');
  };

  const handleOpen = useLinkHandler((event, id) => {
    return '/manifests/' + id;
  });

  const handleListStateChange = useCallback(
    (state) => {
      history.replace(history.location.pathname, state);
    },
    [history],
  );

  return (
    <Switch>
      <Route exact path='/manifests(|/add)'>
        <Route path='/manifests/add'>
          <Modal open={true} onClose={handleAbort}>
            <ManifestAddForm onSubmit={handleAdd} />
          </Modal>
        </Route>
        <Paper className={classes.listContainer}>
          <h1 className={classes.title}>Manifests</h1>
          <Link to='/manifests/add' className={classes.add}>
            <Button circle title='add'>
              <Icon>add</Icon>
            </Button>
          </Link>
          {(() => {
            const { limit, startAtHistory, order, query } = history.location?.state || {};
            return (
              <ManifestList
                onRowClick={handleOpen}
                onStateChange={handleListStateChange}
                className={classes.list}
                defaultLimit={limit}
                defaultStartAtHistory={startAtHistory}
                defaultOrder={order}
                defaultQuery={query}
              />
            );
          })()}
        </Paper>
      </Route>
      <Route
        path='/manifests/:id'
        render={({ match }) => {
          return <ManifestPage id={match.params.id} />;
        }}
      />
    </Switch>
  );
};

export default withStyles(styles)(ManifestListPage);
